import React from 'react'

import { Box, Typography } from "@mui/material"


export default function userColumn() {

	return {
		name: 'user',
		label: 'User',
		options: {
			filterType: 'textField',
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Typography>{value}</Typography>
			</Box>
		}
	}
}